import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';

const SuccessMessage = ({ message, visible }) => (
    <Alert color="success" isOpen={visible}>
        {message}
    </Alert>
)

SuccessMessage.propTypes = {
    message: PropTypes.string.isRequired,
};

export default SuccessMessage;
